import { REGIONS } from "./region";

export const REGIONAL_CONTACT = {
  [REGIONS.US]: {
    label: "United States",
    phone: "+1 346 438 3551",
    location: "Houston, TX",
  },
  [REGIONS.CA]: {
    label: "Canada",
    phone: "+1 416 800 2724",
    location: "Scarborough, ON",
  },
  [REGIONS.UKROI]: {
    label: "United Kingdom & Ireland",
    phone: "+353 1 575 5310",
    location: "Edenderry, County Offaly",
  },
};

export const CONTACT_EMAIL = "info@evonpolishing.com";
